import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
    return (
        <main className="min-h-screen flex items-center justify-center relative overflow-hidden bg-bg-deep pt-28 md:pt-48">
            <Helmet>
                <title>404 - Page Not Found | Zaptopay</title>
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-primary/5 blur-[150px] rounded-full -z-10"></div>
            <div className="container text-center relative z-10" data-aos="zoom-in">
                <h1 className="text-8xl md:text-9xl font-black mb-4 text-primary glow-text">404</h1>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white uppercase tracking-wider">System Error: Route Not Found</h2>
                <p className="text-text-muted text-lg max-w-md mx-auto mb-10">
                    The requested pipeline does not exist on our servers. Please verify the URL or return to the main dashboard.
                </p>
                <Link to="/" className="inline-flex items-center gap-3 px-8 py-4 bg-[#00ff88] text-black text-sm font-black uppercase tracking-[0.12em] rounded-xl hover:bg-white transition-all shadow-[0_0_30px_rgba(0,255,136,0.4)] hover:shadow-[0_0_50px_rgba(0,255,136,0.6)] animate-pulse-whatsapp">
                    Return to Home
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right">
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </Link>
            </div>
        </main>
    );
};

export default NotFound;
